import {
  // 壁纸分分类
  GET_WP_CATEGORY_LABELS,
  GET_WP_CATEGORY_IMGINFO,
  // 壁纸推荐
  GET_WP_BANNER_LIST,
  GET_WP_RECOMMEND_LIST,
  SET_WP_DETAIL_LIST,
  GET_WP_DETAIL_RECO_BANNER,
  GET_WP_RECO_BANNER,
  GET_WP_RECO_GROUP,
  GET_WP_RANK_MORE,
  // 壁纸其他操作
  GET_WP_OPTERAYTION,
  // 锁屏壁纸List
  GET_WP_SCREEN_LIST,
  // 壁纸公共
  WP_UPDATE_PREVIEW,
  WP_ADD_DOWNLOAD_IMG,
  WP_REMOVE_DOWNLOAD_IMG,
  WP_UPDATE_STATUS_DOWNLOAD_IMG,
  WP_UPDATE_PROGRESS_DOWNLOAD_IMG,
  // 壁纸 作家列表
  GET_WP_AUTHOR_LIST,
  GET_WP_AUTHOR_DETAIL,
  GET_WP_AUTHOR_SHOWREEL,
  SET_WP_CATEGORY_STATUS,
  SET_SCROLL,
  CLEAR_WALLPPER_LIST,
  SET_WP_PRODUCT_INFO,
  WP_PAY_DOWNLOAD_COUNT,
  WP_SET_SHOW_ORDER,
  WP_SET_SHOW_TURN_START,
  WP_SET_SHOW_TURN_STOP,
  WP_SET_SHOW_TURN_LIMIT,
  WP_BATCH_SHOW,
  SET_BATCH_INFO,
  HIDE_BATCH_ADD,
  EMPTY_BTNADD,
} from '../constants/wallpaper';

// 壁纸---分类
export const getCategoryLabels = payload => ({
  type: GET_WP_CATEGORY_LABELS,
  payload,
});
export const getCategoryImgInfo = payload => ({
  type: GET_WP_CATEGORY_IMGINFO,
  payload,
});

// 壁纸精选
export const getBannerList = payload => ({
  type: GET_WP_BANNER_LIST,
  payload,
});
export const getRecommendList = payload => ({
  type: GET_WP_RECOMMEND_LIST,
  payload,
});
export const getDetailReco = payload => ({
  type: GET_WP_DETAIL_RECO_BANNER,
  ...payload,
});
export const setDetailList = payload => ({
  type: SET_WP_DETAIL_LIST,
  ...payload,
});
export const getRecoBanner = param => ({
  type: GET_WP_RECO_BANNER,
  ...param,
});
export const getRecoGroup = param => ({
  type: GET_WP_RECO_GROUP,
  ...param,
});
export const getRankList = param => {
  return {
    type: GET_WP_RANK_MORE,
    ...param,
  };
};

// 壁纸其他操作
export const operationImg = param => ({
  type: GET_WP_OPTERAYTION,
  param,
});

// 锁屏操作
export const getWpScreenList = param => ({
  type: GET_WP_SCREEN_LIST,
  param,
});

// 用户预览壁纸
export const updatePreviewInfo = info => ({
  type: WP_UPDATE_PREVIEW,
  info,
});
// 添加壁纸下载任务
export const addDownloadImg = param => ({
  type: WP_ADD_DOWNLOAD_IMG,
  ...param,
});
// 添加壁纸下载任务
export const removeDownloadImg = param => ({
  type: WP_REMOVE_DOWNLOAD_IMG,
  ...param,
});
// 更新壁纸下载状态
export const updateDownloadImgStatus = param => {
  return {
    type: WP_UPDATE_STATUS_DOWNLOAD_IMG,
    ...param,
  };
};
export const updateDownloadImgProgress = param => {
  return {
    type: WP_UPDATE_PROGRESS_DOWNLOAD_IMG,
    ...param,
  };
};

export const getAuthorList = payload => ({
  type: GET_WP_AUTHOR_LIST,
  payload,
});

export const getAuthorDetail = payload => ({
  type: GET_WP_AUTHOR_DETAIL,
  payload,
});

export const getAuthorShowreel = payload => ({
  type: GET_WP_AUTHOR_SHOWREEL,
  payload,
});

export const setCategoryStatus = payload => ({
  type: SET_WP_CATEGORY_STATUS,
  payload,
});

// 设置壁纸高度相关信息
export const setScroll = payload => ({
  type: SET_SCROLL,
  payload,
});

// 清除某些壁纸list数据，解决一个bug
export const clearWallpperList = payload => ({
  type: CLEAR_WALLPPER_LIST,
  payload,
});

// 设置壁纸商品相关信息
export const setWpProductInfo = payload => ({
  type: SET_WP_PRODUCT_INFO,
  payload,
});

// 更新壁纸下载张数
export const updateWpPayDownCount = payload => ({
  type: WP_PAY_DOWNLOAD_COUNT,
  payload,
});

// 显示下单弹框
export const updateShowWpOrder = payload => ({
  type: WP_SET_SHOW_ORDER,
  payload,
});

// 显示第一次设置轮播弹框 8.5
export const updateShowWpTurnStart = payload => ({
  type: WP_SET_SHOW_TURN_START,
  payload,
});

// 显示轮播停止弹框 8.5
export const updateShowWpTurnStop = payload => ({
  type: WP_SET_SHOW_TURN_STOP,
  payload,
});

// 显示轮播張数限制弹框 8.5
export const updateShowWpTurnLimit = payload => ({
  type: WP_SET_SHOW_TURN_LIMIT,
  payload,
});

// 判断是否展示批量添加弹框 8.7
export const determineBatchShow = payload => ({
  type: WP_BATCH_SHOW,
  payload,
});

// 是否展示批量添加弹框内容
export const showBatchAddInfo = payload => ({
  type: SET_BATCH_INFO,
  payload,
});

// 批量添加成功后不展示弹框
export const hideBatchAdd = payload => ({
  type: HIDE_BATCH_ADD,
  payload,
});

// 退出页面后清空显示的信息
export const emptyBtnAdd = payload => ({
  type: EMPTY_BTNADD,
  payload,
});
